// extracted by mini-css-extract-plugin
export default {"amount":"StakedCard_amount__Ijj2e","small":"StakedCard_small__n-KEk","value":"StakedCard_value__W3Yo9"};